/** Contains the constants signalR. */

/**
 * Path of the SignalR hub, appended to `environment.realtimeHubUrl`. Together they
 * address SignalXO — the dedicated realtime delivery service that replaced
 * AlertService's hub.
 *
 * Renamed from `ALERT_HUB_PATH` because the hub is no longer part of AlertService:
 * alerts are one of six message types SignalXO delivers, and AlertService now owns
 * only the alert inbox over REST (`/alertservice/api/alert`, still in use).
 *
 * Base URL and path are split the same way `hierarchyWidgetApiUrl` and
 * `hierarchyWidgetBasePath` are, because SignalXO is reached on its own
 * per-environment domain rather than through the API host. That domain is created
 * automatically by the deployer's promote pipeline for every environment SignalXO
 * is promoted to — which is why this is not a route under `baseApiUrl`.
 */
export const REALTIME_HUB_PATH = '/hub';

/** One Minute to milliseconds. */
export const MINUTE_TO_MILISEC = 60000;

/** Automatic reconnections for signalR given in millisecond. */
export const AUTO_RECONNECTIONS = [
  0,
  3000,
  5000,
  10000,
  15000,
  30000,
  MINUTE_TO_MILISEC,
  MINUTE_TO_MILISEC * 2.5,
  MINUTE_TO_MILISEC * 5,
  MINUTE_TO_MILISEC * 10,
  MINUTE_TO_MILISEC * 15,
  MINUTE_TO_MILISEC * 30,
  MINUTE_TO_MILISEC * 60,
];

/** Number of attempts limit to start connection. */
export const ATTEMPTS_LIMIT_CONNECTION = 5;
